import type { ReactNode } from 'react';

export interface DetailFieldItem {
  label: string;
  value: ReactNode;
}

const DetailFields = ({ items }: { items: DetailFieldItem[] }) => (
  <dl className='grid grid-cols-[max-content_1fr] gap-x-4 gap-y-2 text-sm'>
    {items.map((item) => (
      <div key={item.label} className='contents'>
        <dt className='text-gray-600 font-medium'>{item.label}</dt>
        <dd className='text-gray-900 break-words'>{item.value}</dd>
      </div>
    ))}
  </dl>
);

export default DetailFields;
